import { Subject, Observable, BehaviorSubject } from 'rxjs';

import { Injectable } from '@angular/core';

import { SnOperationalView } from '@lib/api/entities';

@Injectable({ providedIn: 'root' })
export class OperationalViewsService {
  private readonly _viewAdded$ = new Subject<SnOperationalView>();
  private readonly _params$ = new BehaviorSubject<SnOperationalView>(null);

  constructor() {}

  get viewsChanges$(): Observable<SnOperationalView> {
    return this._viewAdded$.asObservable();
  }

  get params(): SnOperationalView {
    return this._params$.value;
  }

  public emitView(view: SnOperationalView): void {
    this._viewAdded$.next(view);
  }

  public emitParams(data: any): void {
    this._params$.next(data);
  }
}
